<template>
    <div :class="PanelClass" v-show="isActive">
  
      <div class="payitemavailable " > <!-- v-show="priorValid" -->
      
        <addpayment_culinary buttonClass='btn cashpaymentbutton' name="Cash" :defaultAmount="due" @save="addPayItem" @opendrawer="OpenDrawer" 
              v-if="showCash" :disabled="disablePayments"/>
        <addpayment_culinary buttonClass='btn paymentbutton' name="Check" :defaultAmount="due" @save="addPayItem" :isCheck="paramTrue" :numberDataLabel="checkNumberDataLabel" 
              v-if="showCheck" :allowOverAvailableAmount="allowPaymentOverDue" :availableAmount="due" :disabled="disablePayments"/>
        
        <addpayment_culinary buttonClass='btn paymentbutton' name="Card" :defaultAmount="due" @save="addPayItem" :numberDataLabel="cardNumberDataLabel" 
              v-if="showBankcard" :allowOverAvailableAmount="allowPaymentOverDue" :availableAmount="due" :disabled="disablePayments"/>

         <addpayment_culinary buttonClass='btn paymentbutton' name="Gift Certificate" :defaultAmount="due" @save="addPayItem" 
            v-if="showGiftCertificate" :allowOverAvailableAmount="allowPaymentOverDue" :availableAmount="due" :numberDataLabel="certNumberDataLabel" :disabled="disablePayments"/>
         <addpayment_gift buttonClass="btn paymentbutton" name="Gift Card" :defaultAmount="due" @save="addPayItem" 
            v-if="showGiftcard" :disabled="disablePayments"/>
         
        <div class="allpmt">
            <splitticket :showButton="paramTrue" buttonClass="btn paymentbutton"/>
            <!-- <smallbutton buttonclass="btn paymentbutton" toplabel="Split Ticket" @click="showSplitTicket"/> -->
             <div v-for="li in getGuestTotals" v-bind:key="li.name" >
                <div v-if="li.total>0">
                  <label class="margin10">{{ li.name }}</label>
                  <label class="margin10">TOTAL ${{ li.total }}</label>
                  <label class="margin10" v-if="li.totalpaid!=0">PAID ${{ li.totalpaid }}</label>
                  <linkbutton toplabel="Receipt"/>
                </div>
                
             </div>
        </div>  
       
            
        

      </div>
      <div class="payitemadded ">
        <label for class="text subtitle">Payments</label>
        <payitem v-for="payItem in payItems" v-bind:key="payItem.id" v-bind:payItem="payItem"  @removeitem="removepayitem" />
        <label for class="text text-right totaltext">Payment Total: {{ payTotal|toCurrency }}</label>
        <label for class="text text-right totaltext paycolor">Due: {{ due|toCurrency }}</label>
        <label for class="text text-right totaltext paycolor">Change: {{ change|toCurrency }}</label>
        <div v-show="isValid && zeroDue">

          <button class="btn actionbutton narrowbutton"  @click="receiptOnNewPage" v-if="receiptPrinterType=='newpage'" >Print Receipt</button>
          <button ref="printthereceipt" class="btn actionbutton narrowbutton"  v-print="'#receiptdatadiv'" v-if="receiptPrinterType=='print'">Print Receipt</button>

        </div>
        
        
  
      </div>
  
  
      <div class="nextbutton">
        <div class="nextbutton">
          <label class="pleasewait" v-if="inPayment">Processing, please wait...</label>
        </div>
  
        <div v-if="showPayMultCard">
          <button v-for="payItem in payItems_unprocessedCardOnly" v-bind:key="payItem.id"   class="btn actionbutton" 
              @click="process_terminaltest_single(payItem)" >Process Card for ${{payItem.price}}</button>
        </div>
  
        <button class="btn actionbutton" @click="process_terminaltest" v-show="isValid && zeroDue && !showPayMultCard" :disabled="pleaseWait">{{completeText}}</button>
        <receiptoptions ref="receiptoptions" @close="completeIfAuto" :showButton="!autoReceiptAfterProcess"/>  
        <div hidden>
            <div  class="receiptclass" id="receiptdatadiv" v-if="receiptData!=null" >
              <label>{{receiptData}}</label>
            </div>
          </div>
          
          <div id="drawerdiv">
            <label class="drawerfont"></label>
          </div>
      </div>
   
    </div>
  </template>
  
  <script>
  import {mapFields} from 'vuex-map-fields'
  import payitem from '../actions/payitem.vue'
  import smallbutton from '../controls/button.vue'
  import format from '../../style/format.js'
  import addpayment_culinary from '../actions/addpayment_culinary.vue'
  import addpayment_gift from '../actions/addpayment_gift.vue'
  import print from 'vue-print-nb'
  import pay from '../../services/pay.js'
  import pos from '../../services/pos.js'
  import pos_culinary from '../../services/pos_culinary.js'
  import splitticket from '../actions/splitticket.vue'
  import receiptoptions from '../actions/receiptoptions.vue'
  import linkbutton from '../controls/linkbutton.vue'
  export default {
    data() {
      return {
        paramTrue:true,
        paramFalse:false,
  
      };
    },
    directives:{
      print
    },
    components:{
      payitem,
      addpayment_culinary,
      addpayment_gift,
      smallbutton,
      splitticket,
      receiptoptions,
      linkbutton
  
    },
    mixins:[format,pay,pos,pos_culinary],
    props: ["panelIndex"],
    computed: {
      ...mapFields([
              
          ]),
          
      
      isActive: function() {
        return this.panels[this.panelIndex].active;
      },
      isValid: function() {
        return this.panels[this.panelIndex].valid;
      },
      
      priorValid: function() {
        return this.panels[this.panelIndex - 1].valid;
      },
      
      PanelClass: function() {
        var classes = "panel-full panel payfull ";
        if (this.inPayment == true) {
          classes += " panel-unavailable";
        }
        return classes;
      },
      
      
      
    },
    methods: {
      
      toNext: function() {
        if(this.AutoStartOver){this.startOver();}
        else{
          var nextPanelIndex = Number(this.panelIndex) + 1;
          this.$store.dispatch('setActivePanel',nextPanelIndex);
          this.panels[2].available = false;
          this.panels[1].available = false;
          this.panels[0].available = false;
        }
        
      },
      startOver: function() {
        this.$store.dispatch('startOver');
  
      },
      
  
    },
    mounted: function() {
      //this.onInit();
    }
  };
  </script>
  <style scoped>
  .drawerfont{
    font:'control';
  }
  .payitemavailable {
    grid-area: payavailable;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    height:100px;
  }
  .payitemadded {
    grid-area: payadded;
    display: flex;
    flex-direction: column;
    border-left: 1px solid gray;
    padding-left:20px;
    margin-left:10px;
    text-align:right;
    align-items: right;
  }
  
  .payfull {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto 80px;
    grid-template-areas:
      "payavailable payadded"
      "open next";
    padding: 20px;
  }
  .allpmt{
    border-top:1px solid gray;
    width:100%;
    text-align: left;
  }
  .narrowbutton{
    width:100px;
  }
  .receiptclass{
    margin-top:120px;
    white-space: pre-wrap;
  
  } 
  </style>